import { Component, Inject, OnInit, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient } from "@angular/common/http";
import { FormGroup, FormBuilder } from '@angular/forms';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from "@angular/material/chips";

@Component({
    selector: "inspection-filter",
    templateUrl: './inspection-filter.component.html',
    styleUrls: ['../../../style/form.component.less', 'inspection-filter.component.less', '../../../style/expand-collapse-panel.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None
})

export class InspectionFilterComponent implements OnInit {

    form!: FormGroup;
    @Output() outputFilter = new EventEmitter<InspectionFilter>();

    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];

    inspectionIds: string[] = [];
    unitIds: string[] = [];

    constructor(
        private http: HttpClient
        , private fb: FormBuilder
        , @Inject('BASE_URL') private baseUrl: string
    ) {
    }

    ngOnInit() {
        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
        });
    }

    changeTypeButton() {
        return this.inspectionIds.length < 1 && this.unitIds.length < 1
    }

    applyFilter(event: MatChipInputEvent, list: string): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            switch (list) {
                case 'inspectionids':
                    this.inspectionIds.push(value.replace('+', '').trim()); break;
                case 'unitids':
                    this.unitIds.push(value.replace('+', '').trim()); break;
            }
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(item: string, list: string): void {
        let index = -1
        switch (list) {
            case 'inspectionids':
                index = this.inspectionIds.indexOf(item);
                if (index >= 0)
                    this.inspectionIds.splice(index, 1);
                break;
            case 'unitids':
                index = this.unitIds.indexOf(item);
                if (index >= 0)
                    this.unitIds.splice(index, 1);
                break;
        }
    }

    onFilter() {
        const filter: InspectionFilter = {
            'InspectionIds': this.inspectionIds,
            'UnitIds': this.unitIds
        }
        this.outputFilter.emit(filter);
    }
}